import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, CircularProgress, DialogActions, DialogContent, DialogTitle, FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select } from "@material-ui/core";
import { getHeatPumpModels, updateHeatPumpDevice } from "../../containers/Admin/HeatPumpDevices/actions";

export default function EditSeriesType(props) {
  const { details: oldDetails, refreshData } = props?.globalModal?.data || {}
  const dispatch = useDispatch();

  const { heatPumpDevices: { heatPumpModels, heatPumpModelsLoading } = {} } = useSelector(state => state || {})
  const [isLoading, setIsLoading] = useState(false);
  const [details, setDetails] = useState({ ...oldDetails });
  const [errors, setErrors] = useState({});

  const closeModal = () => {
    props.closeModal();
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "series_type") {
      setDetails(prev => ({ ...prev, [name]: value, model_number: "" }))
    } else {
      setDetails(prev => ({ ...prev, [name]: value }))
    }
  };

  const onSubmit = async () => {
    if (!details.model_number) {
      return setErrors({ model_number: "Model Name is required" });
    } else {
      setErrors({});
    }

    setIsLoading(true);


    const request = { ...details };
    dispatch(updateHeatPumpDevice(request))
      .then((res) => {
        if (refreshData) {
          refreshData()
        }
        closeModal();
      })
      .catch((err) => {
        console.log(err.message);
      }).finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      <DialogTitle className="heat_pump_modal_title">
        <Grid item md={12} className="d-flex">
          <h6>Update Series Type & Model Name</h6>
        </Grid>
      </DialogTitle>
      <DialogContent dividers className="heat_pump_dialog_content">
        <FormControl variant="outlined" fullWidth style={{ marginBottom: 20 }}>
          <InputLabel>Series Type</InputLabel>
          <Select
            label="Series Type"
            name="series_type"
            value={details.series_type || ""}
            onChange={handleChange}
            MenuProps={{
              disablePortal: true,
              PaperProps: {
                style: {
                  maxHeight: 48 * 4.5 + 8,
                  marginTop: 50,
                },
              },
            }}
          >
            <MenuItem value={"select"}>Select</MenuItem>
            <MenuItem value={"pro"}>Pro</MenuItem>
            {/* <MenuItem value={"ultra"}>Ultra</MenuItem> */}
          </Select>
        </FormControl>

        <FormControl variant="outlined" fullWidth>
          <InputLabel>Model Name</InputLabel>
          <Select
            label="Model Name"
            name="model_number"
            value={details.model_number || ""}
            onChange={handleChange}
            MenuProps={{
              disablePortal: true,
              PaperProps: {
                style: {
                  maxHeight: 48 * 6 + 8,
                  marginTop: 50,
                },
              }
            }}
          >
            {
              heatPumpModels?.data
                ?.filter(model => {
                  if (details.series_type === "select") {
                    return model.model_name?.toLowerCase().startsWith("hpa1")
                  } else if (details.series_type === "ultra") {
                    return model.model_name?.toLowerCase().startsWith("hpau")
                  } else if (details.series_type === "pro") {
                    return !model.model_name?.toLowerCase().startsWith("hpa1") && !model.model_name?.toLowerCase().startsWith("hpau")
                  }
                })
                ?.map(model => (
                  <MenuItem key={model.id} value={model.id}>{model.model_name}</MenuItem>
                ))
            }
          </Select>
          {errors?.model_number && <FormHelperText style={{ color: 'red', textAlign: 'left', padding: "0px", margin: '0px' }}>{errors?.model_number}</FormHelperText>}
        </FormControl>
      </DialogContent>
      <Grid>
        <DialogActions className="heat_pump_dialog_action">
          <Button
            className={`cus-btn-modal-submit ${isLoading ? "disabled" : ""}`}
            onClick={closeModal}>
            Cancel
          </Button>
          <Button
            className={`cus-btn-modal-submit ${isLoading ? "disabled" : ""}`}
            onClick={isLoading ? null : onSubmit}>
            {isLoading ? <CircularProgress size={18} color="white" /> : "Update"}
          </Button>
        </DialogActions>
      </Grid>
    </>
  );
}
